import { Lesson, Absence } from 'src/store/models/timetable/index.js'
import { LessonGrade } from 'src/store/models/pivot/index.js'

import CRUD from 'src/store/models/helper/CRUD.js'
import Timetable from 'src/api/timetable.js'

export class Grade extends CRUD {
  static entity = 'grades'
  static fetchUrl = Timetable.timetableGradesUrl()

  static fields () {
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      channel_id: this.attr(null),
      shortcut: this.string(''),
      name: this.string(''),
      description: this.string(''),
      migrate_at: this.attr(new Date()),
      range: this.attr(null),
      order: this.number(null).nullable(),
      category: this.string(null).nullable(),
      intern_id: this.attr(null),
      intern_data: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      lessons: this.belongsToMany(Lesson, LessonGrade, 'grade_id', 'lesson_id'),
      absences: this.morphMany(Absence, 'target_id', 'target_type'),
      meta: this.attr({})
    }
  }
}

export default Grade
